import { FC } from 'react';
import { Box, Stack, ThemeProvider } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout, MplTabsSkeleton, SkeletonBlock } from '@mopla/ui';

import { TicketCardSkeleton } from './components';

interface IOperatorTicketsLoadingProps {
	onBack: () => void;
	title?: string;
}

export const OperatorTicketsLoading: FC<IOperatorTicketsLoadingProps> = ({
	onBack,
	title = '',
}) => {
	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={title}
				onBack={onBack}
				scrollable
				dataTestId="operator-tickets-page-loading"
				isTitleLoading={!title}
			>
				{/* Operator wordmark reserve (Figma branding strip ≈59px), 8px to tabs. */}
				<Box
					sx={{
						mx: '14px',
						pt: '8px',
						mb: 1,
						height: 60,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<SkeletonBlock w="80%" h={54} r={8} />
				</Box>
				<Stack gap={2}>
					<MplTabsSkeleton tabsCount={2} />
					<Stack gap={1}>
						<Stack direction="row" alignItems="center" gap={1}>
							<SkeletonBlock w={24} h={24} r={6} />
							<SkeletonBlock w={180} h={18} r={6} />
						</Stack>
						<TicketCardSkeleton />
						<TicketCardSkeleton />
						<TicketCardSkeleton />
						<TicketCardSkeleton />
						<TicketCardSkeleton />
					</Stack>
					<Stack direction="row" alignItems="center" gap={1}>
						<SkeletonBlock w={24} h={24} r={6} />
						<SkeletonBlock w={160} h={16} r={6} />
					</Stack>
				</Stack>
			</DTicketPageLayout>
		</ThemeProvider>
	);
};
